import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appUploaderLoading]'
})
export class UploaderLoadingDirective {
  @Input() message: string;

  constructor(public templateRef: TemplateRef<unknown>, public containerRef: ViewContainerRef) {
    this.containerRef.createEmbeddedView(templateRef, {errors: this.message});
  }
}
